import styles from './styles.module.css';
import { useState, useEffect, useRef, useContext } from 'react';

import SocketContext from "../socket-context";

// const Messages = ({ socket }) => {
const Messages = ({ socket, username }) => {
  // const [messagesRecieved, setMessagesReceived] = useState([]);

  const messagesColumnRef = useRef(null);

  // Runs whenever a socket event is recieved from the server
  // useEffect(() => {
  //   socket.on('receive_message', (data) => {
  //     console.log(data);
  //     setMessagesReceived((state) => [
  //       ...state,
  //       {
  //         message: data.message,
  //         username: data.username,
  //         __createdtime__: data.__createdtime__,
  //       },
  //     ]);
  //   });

  //   // Remove event listener on component unmount
  //   return () => socket.off('receive_message');
  // }, [socket]);

  const socketData = useContext(SocketContext);
  console.log("socketData-->>", socketData)

  // useEffect(() => {
  //   // Last 100 messages sent in the chat room (fetched from the db in backend)
  //   socket.on('last_100_messages', (last100Messages) => {
  //     console.log('Last 100 messages:', JSON.parse(last100Messages));
  //     last100Messages = JSON.parse(last100Messages);
  //     // Sort these messages by __createdtime__
  //     last100Messages = sortMessagesByDate(last100Messages);
  //     socketData.setMessagesReceived((state) => [...last100Messages, ...state]);
  //   });

  //   return () => socket.off('last_100_messages');
  // }, [socket]);

  // Scroll to the most recent message
  useEffect(() => {
    messagesColumnRef.current.scrollTop =
      messagesColumnRef.current.scrollHeight;
  // }, [messagesRecieved]);
  }, [socketData.messagesRecieved]);

  // function sortMessagesByDate(messages) {
  //   return messages.sort(
  //     (a, b) => parseInt(a.__createdtime__) - parseInt(b.__createdtime__)
  //   );
  // }

  function formatDateFromTimestamp(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleString();
  }

  return (
    <div className={styles.messagesColumn} ref={messagesColumnRef}>
      {socketData.messagesRecieved.map((msg, i) => (
        <div className={styles.message} key={i}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span 
              className={styles.msgMeta}
              style={{
                fontWeight: `${msg.username === username ? 'bold' : 'normal'}`,
              }}
            >
              {msg.username}
            </span>
            <span className={styles.msgMeta}>
              {formatDateFromTimestamp(msg.__createdtime__)}
            </span>
          </div>
          <p className={styles.msgText}>{msg.message}</p>
          <br />
        </div>
      ))}
    </div>
  );
};

export default Messages;